/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    UPDATE_GENERAL, UPDATE_GENERAL_TEXT, VALIDATE_GENERAL_TEXT,
    UPDATE_GENERAL_ADVANCE_SETTINGS, UPLOADING_LOGO,
    SAVING_GENERAL, SAVE_GENERAL,
    SAVING_MODERATION, SAVE_MODERATION,
    SAVING_AVATAR_PACK, SAVE_AVATAR_PACK,
    UPDATE_MODERATION, UPDATE_MODERATION_ADVANCE_SETTINGS,
    UPDATE_COMMUNITY, SAVING_COMMUNITY, SAVE_COMMUNITY,
    SAVING_COLOR_CONFIGURATION, SAVE_COLOR_CONFIGURATION,
    UPDATE_COMMENTS_TREE, SAVING_COMMENTS_TREE, SAVE_COMMENTS_TREE,
    CANCEL_SECTION, GET_CONFIGURATION, FETCHING_FAIL, FETCHING_CONFIGURATION,
    SET_COMMENTING_UNIT_UUID
} from 'state/actions/commentingState/configurationStatus';
import { COMMUNITY_UPLOAD_IMAGE, COMMUNITY_DISCARD_IMAGE } from 'state/actions/commentingState/addOnsStatus';
//utils
import { transpileConfigurationData, transpileColorSchemaData, transpileModerationData, transpileGeneralData } from 'state/reducers/commentingState/transpilers';


/* ========== ~~~~~~~~~~ CONFIG STATE > COMMENTS STATUS: REDUCER ~~~~~~~~~~ ========== */
// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = transpileConfigurationData({});


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const configStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_CONFIGURATION:
            newState = transpileConfigurationData(action.data);
            return newState;
        case FETCHING_CONFIGURATION:
            newState.fetchingConfigs = action.status;
            return newState;
        case FETCHING_FAIL:
            newState.fetchingConfigsFailed = true;
            return newState;
        case UPDATE_GENERAL:
            newState.general[action.prop] = action.value;
            newState.general.updated = true;
            return newState;
        case UPDATE_GENERAL_TEXT:
            newState.general[action.prop].value = action.value;
            newState.general.updated = true;
            return newState;
        case VALIDATE_GENERAL_TEXT:
            newState.general[action.prop].valid = action.valid;
            return newState;
        case UPDATE_GENERAL_ADVANCE_SETTINGS:
            newState.general.advancedSettings[action.prop] = action.value;
            newState.general.updated = true;
            return newState;
        case UPLOADING_LOGO:
            newState.general.uploadingLogo = action.status;
            return newState;
        case SAVE_GENERAL:
            newState.stored_general = newState.general;
            newState.general.updated = false;
            return newState;
        case SAVING_GENERAL:
            newState.general.savingGeneral = action.status;
            return newState;
        case UPDATE_MODERATION:
            newState.moderation[action.prop] = action.value;
            newState.moderation.updated = true;
            return newState;
        case UPDATE_MODERATION_ADVANCE_SETTINGS:
            newState.moderation.advancedSettings[action.prop] = action.value;
            newState.moderation.updated = true;
            return newState;
        case SAVING_MODERATION:
            newState.moderation.savingModeration = action.status;
            return newState;
        case SAVE_MODERATION:
            newState.stored_moderation = newState.moderation;
            newState.moderation.updated = false;
            return newState;
        case UPDATE_COMMUNITY:
            newState.community[action.prop] = action.value;
            newState.community.updated = true;
            return newState;
        case SAVING_COMMUNITY:
            newState.savingCommunity = action.status;
            return newState;
        case SAVE_COMMUNITY:
            newState.community = action.data;
            newState.stored_community = action.data;
            newState.community.updated = false;
            return newState;
        case CANCEL_SECTION:
            newState[action.section] = newState[`stored_${action.section}`];
            return newState;
        case SAVE_COLOR_CONFIGURATION:
            newState.colorSchema = transpileColorSchemaData(action.data);
            return newState;
        case SAVING_COLOR_CONFIGURATION:
            newState.savingColorConfiguration = action.status;
            return newState;
        case SAVING_AVATAR_PACK:
            newState.savingAvatarPack = action.status;
            return newState;
        case SAVE_AVATAR_PACK:
            newState.avatarPack = action.data;
            newState.stored_avatarPack = newState.avatarPack;
            return newState;
        case UPDATE_COMMENTS_TREE:
            newState.commentsTree[action.prop] = action.value;
            newState.commentsTree.updated = true;
            return newState;
        case SAVING_COMMENTS_TREE:
            newState.savingCommentsTree = action.status;
            return newState;
        case SAVE_COMMENTS_TREE:
            newState.commentsTree.updated = false;
            newState.stored_commentsTree = newState.commentsTree;
            return newState;
        case COMMUNITY_UPLOAD_IMAGE:
            newState.community.placeholderImageUrl = action.data.imageUrl;
            newState.community.placeholderImageName = action.data.imageUrl.split('/').pop();
            return newState;
        case COMMUNITY_DISCARD_IMAGE:
            newState.community.placeholderImageUrl = action.data;
            newState.community.placeholderImageName = null;
            return newState;
        case SET_COMMENTING_UNIT_UUID:
            newState.commentingUnitUUID = action.data;
            return newState;
        default:
            return state;
    }
};

/* ++++++++++ --------------- CUSTOM METHODS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default configStatus;
